import React from 'react';
import {Text, View} from 'react-native';
import {Props} from './PointsCardModel';
import {useStyles} from '../../../shared/hooks/styles';
import {DeviceSize} from '../../../shared/theme/helpers';
import {images} from '../../../assets/icons';
import {Loader} from '../../../shared/components/loader';
import {useSelector} from 'react-redux';
import {dobroruDataLoadingSelector} from '../../../redux/selectors/dobroru';

export default ({score}: Props) => {
  const styles = useStyles(({theme, isDesktop, mediaOnly}) => ({
    container: {
      maxHeight: 125,
      backgroundColor: theme.color.backgroundMenuColor,
      marginBottom: 25,
      flexDirection: 'row',
      ...mediaOnly(DeviceSize.desktop, {}, {alignSelf: 'center', marginHorizontal: 'auto'}),
    },
    list: {
      flexDirection: isDesktop ? 'row' : 'column',
      marginLeft: 10,
    },
    listItem: {
      flexDirection: 'column',

      ...mediaOnly(
        DeviceSize.desktop,
        {
          flex: 1,
          marginRight: 30,
        },
        {},
      ),
    },
    listItemLast: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          flex: 2,
          marginRight: 0,
        },
        {
          marginBottom: 0,
        },
      ),
    },
    listTitleText: {
      ...(isDesktop ? theme.fonts.h6 : theme.fonts.bodySmallLight),
      color: theme.color.primaryBlackColor,
      ...mediaOnly(DeviceSize.mobile, {minWidth: 200}),
      ...mediaOnly(DeviceSize.tablet, {minWidth: 300, marginLeft: 50}),
      ...mediaOnly(DeviceSize.desktop, {textAlign: 'center'}),
    },
    listItemTitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          marginBottom: 12,
        },
        {},
      ),
    },
    listItemValue: {},
    listValueText: {
      ...(isDesktop
        ? {
            ...theme.fonts.h6Light,
            marginTop: 5,
          }
        : theme.fonts.body),
      color: theme.color.textColor,
    },
    listValueTextBold: {
      ...theme.fonts.h1,
      color: theme.color.primaryBlackColor,
    },
    listValueTextSmall: {
      ...(isDesktop ? theme.fonts.bodySmallLight : theme.fonts.body),
      color: theme.color.labelText,
    },
    starImgContainer: {},
    groupItemIcon: {},
  }));

  const isDobroruDataLoading = useSelector(dobroruDataLoadingSelector);

  return (
    <View style={styles.container}>
      <View style={styles.starImgContainer}>
        <View style={styles.groupItemIcon}>
          <images.PointsStart width={78} height={78} />
        </View>
      </View>
      <View style={styles.list}>
        <View style={[styles.listItem, styles.listItemLast]}>
          <View style={styles.listItemTitle}>
            <Text testID='card-info-id' style={styles.listTitleText} numberOfLines={1}>
              Доступно баллов:
            </Text>
          </View>
          <View style={styles.listItemValue}>
            {isDobroruDataLoading ? (
              <Loader size={50} />
            ) : (
              <Text testID='card-number-id' style={styles.listValueTextBold}>
                {score}
              </Text>
            )}
          </View>
        </View>
      </View>
    </View>
  );
};
